import { PersonTypes } from '@frontend/api-person';
import { InsuranceContainer } from './insurance-container';
import { InsuranceTypeProvider } from './providers/insurance-type-provider';
import { PersonInfoStoreProvider } from './providers/person-info-provider';
import { UndefinedOrNull } from './utils/types';

interface Props {
  locationId: string;
  personInfo: UndefinedOrNull<PersonTypes.Person>;
  showInNetworkOrOutNetworkData?: boolean;
  shouldShowHistoryData?: boolean;
}

export const InsuranceTab = ({
  locationId,
  personInfo,
  showInNetworkOrOutNetworkData = true,
  shouldShowHistoryData = true,
}: Props) => {
  return (
    <PersonInfoStoreProvider personInfo={personInfo as PersonTypes.Person} locationId={locationId}>
      <InsuranceTypeProvider>
        <InsuranceContainer
          locationId={locationId}
          personInfo={personInfo}
          showInNetworkOrOutNetworkData={showInNetworkOrOutNetworkData}
          shouldShowHistoryData={shouldShowHistoryData}
        />
      </InsuranceTypeProvider>
    </PersonInfoStoreProvider>
  );
};
InsuranceTab.displayName = 'InsuranceTab';
